export const SALES_INTREST_CALCULATION_REPORT_REQUEST = 'SALES_INTREST_CALCULATION_REPORT_REQUEST';
export const SALES_INTREST_CALCULATION_REPORT_SUCCESS = 'SALES_INTREST_CALCULATION_REPORT_SUCCESS';
export const SALES_INTREST_CALCULATION_REPORT_FAILURE = 'SALES_INTREST_CALCULATION_REPORT_FAILURE';